
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-91614f5e\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader!./modalCardWorkforce.scss")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./modalCardWorkforce.ts"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-91614f5e\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./modalCardWorkforce.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/home/modals/modalCardWorkforce/modalCardWorkforce.vue.html
// module id = 35ms
// module chunks = 2